import React, { useEffect, useState } from 'react'

const AboutUs = () => {
    const [title, setTitle] = useState(null);
    const [description, setDescription] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        fetchCmsData();
    }, [])

    const fetchCmsData = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/cms/`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            });
            const data = await res.json();
            
            // Find the About Us content from CMS data
            const aboutUsContent = data.responseObject.find(
                item => item.title.toLowerCase() === "about us"
            );
            if (aboutUsContent) {
                setTitle(aboutUsContent.title);
                setDescription(aboutUsContent.description);
            }
            
            // Ensure loader shows for at least 0.4 seconds
            setTimeout(() => {
                setIsLoading(false);
            }, 400);
        } catch (error) {
            // console.log("fetch cms error", error);
            setIsLoading(false);
        }
    }
    
    if (isLoading) {
        return (
            <div className="loader-main" style={{ background: "white" }}>
                <div className="loaderaa"></div>
            </div>
        );
    }

    return (
        <>
            <section className="banner-innr mt-150">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <div className="banner-innr-content">
                                <h3 className="fw-bold mb-2">{title || 'About Us'}</h3>
                                <div className="divider mx-auto" style={{
                                    width: '100px',
                                    height: '3px',
                                    backgroundColor: '#ff6b6b',
                                    marginBottom: '20px'
                                }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="about-us">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9 col-md-11">
                            <div className="about-us-card p-4 bg-white shadow-sm rounded">
                                <div 
                                    className="about-us-text"
                                    style={{
                                        lineHeight: '1.8',
                                        color: '#4a4a4a',
                                        fontSize: '16px'
                                    }}
                                    dangerouslySetInnerHTML={{ __html: description }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}

export default AboutUs